const _SETTINGS = {
    "sarri": {
        color: "#582733",
        fullname: "Castellers de Sarrià",
        shortname: "Sarrià",
    },
    "esquerdats": {
        color: "#7F3BB0",
        fullname: "Colla Castellera de l'Esquerra de l'Eixample",
        shortname: "Esquerdats",
    },
    "bergants": {
        color: "#b8da49",
        fullname: "Bergants del Campus de Terrassa",
        shortname: "Bergants",
    },
    "demo": {
        color: "rgb(0,100,150)",
        fullname: "Demostració de l'Aleta",
        shortname: "Demo",
    },
    "berga": {
        color: "#00388c",
        fullname: "Castellers de Berga",
        shortname: "Berga",
    },
    "matossers": {
        color: "#905E28",
        fullname: "Colla Castellera Matossers de Molins de Rei",
        shortname: "Matossers",
    },
    "pastoretsvila": {
        color: "#F5DEB3",
        fullname: "Pastorets de Vilafranca",
        shortname: "Pastorets",
    },
    "llunatics": {
        color: "#1e4696",
        fullname: "Llunàtics UPC Vilanova",
        shortname: "Llunàtics",
    },
    "santpedor": {
        color: "#e1ae04",
        fullname: "Castellers de Santpedor",
        shortname: "Santpedor",
    },
    "pataquers": {
        color: "#F08015",
        fullname: "Pataquers de la URV",
        shortname: "Pataquers",
    },
    "falconsbcn": {
        color: "#fc6262",
        fullname: "Falcons de Barcelona",
        shortname: "Falcons",
    },
    "ganapies": {
        color: "#003153",
        fullname: "Ganàpies de la UAB",
        shortname: "ganapies",
    },
    "trempats": {
        color: "#d3bb90",
        fullname: "Trempats de la UPF",
        shortname: "trempats",
    },
    "arreplegats": {
        color: "#4eb57a",
        fullname: "Arreplegats de la Zona Universitària",
        shortname: "arreplegats",
    },
    "emboirats": {
        color: "#e9133f",
        fullname: "Emboirats de la UVIC",
        shortname: "Emboirats",
    },
    "marracos": {
        color: "#8b8a92",
        fullname: "Marracos de la UdL",
        shortname: "Marracos",
    },
    "descargolats": {
        color: "#e94e96",
        fullname: "Descargolats de l'EEBE",
        shortname: "Descargolats",
    },
    "sagals": {
        color: "#f36300",
        fullname: "Sagals d'Osona",
        shortname: "Sagals",
    },
    "falconsvila": {
        color: "#007a51",
        fullname: "Falcons de Vilafranca del Penedès",
        shortname: "falconsvila",
    },
    "xoriguers": {
        color: "#02b1ea",
        fullname: "Xoriguers de la UdG",
        shortname: "Xoriguers",
    },
    "engrescats": {
        color: "#d6b600",
        fullname: "Engrescats de la URL",
        shortname: "Engrescats",
    },
    "gambirots": {
        color: "#aeb9c4",
        fullname: "Gambirots de la UIB",
        shortname: "Gambirots",
    },
    "passerells": {
        color: "#e0b0ff",
        fullname: "Passerells del TecnoCampus",
        shortname: "Passerells",
    },
    "laietans": {
        color: "#0b8e36",
        fullname: "Laietans de Gramenet",
        shortname: "Laietans",
    },
    "escatllots": {
        color: "#e5a45b",
        fullname: "Escatllots del Pla",
        shortname: "Escatllots",
    },
    "mallorca": {
        color: "#911305",
        fullname: "Castellers de Mallorca",
        shortname: "CdMallorca",
    },
    "falconspiera": {
        color: "#bc1823",
        fullname: "Falcons de Piera",
        shortname: "Piera",
    },
    "eire": {
        color: "#009A49",
        fullname: "Castellers d'Éire",
        shortname: "Éire",
    },
    "potesroges": {
        color: "#ca313d",
        fullname: "Colla Castellera de Vacarisses",
        shortname: "Potes Roges",
    },
    "santfeliu": {
        color: "#d72b83",
        fullname: "Castellers de Sant Feliu",
        shortname: "Sant Feliu",
    },
    "lena": {
        color: "#e0a4cd",
        fullname: "Lena's esdeveniments",
        shortname: "Lena",
    }
    ,
    "penjats": {
        color: "#e30615",
        fullname: "Colla Castellera Penjats del Campus de Manresa",
        shortname: "Penjats",
    },
    "grillats": {
        color: "#741e38",
        fullname: "Colla Castellera Grillats del CBL",
        shortname: "Grillats",
    },
    "santiago": {
        color: "#cccccc",
        fullname: "Colla Castellera Secreta",
        shortname: "Secreta",
    },
    "viladecans": {
        color: "#a8e71e",
        fullname: "Castellers de Viladecans",
        shortname: "Viladecans",
    },
    "castelldefels": {
        color: "#d6b600",
        fullname: "Castellers de Castelldefels",
        shortname: "Castelldefels",
    },
    "nova": {
        color: "#02b1a3",
        fullname: "Nova Muixeranga d'Algemesí",
        shortname: "Nova Muixeranga",
    },
    "andorra": {
        color: "#721e35",
        fullname: "Castellers d'Andorra",
        shortname: "Andorra",
    },
    "baixmontseny": {
        color: "#03989f",
        fullname: "Colla Castellera del Baix Montseny",
        shortname: "Baix Montseny",
    },
    "dracterrassa": {
        color: "#00573F",
        fullname: "Grup del Drac de Terrassa",
        shortname: "Drac Terrassa",
    },
    "torraires": {
        color: "#790000",
        fullname: "Torraires de Montblanc",
        shortname: "Torraires",
    },
    "horta": {
        color: "#205632",
        fullname: "Colla Castellera d'Horta",
        shortname: "Horta",
    },
    "esperxats": {
        color: "#218A87",
        fullname: "Colla Castellera Esperxats de l'Estany",
        shortname: "Esperxats",
    },
    "synera": {
        color: "#6E1229",
        fullname: "Vailets de Synera",
        shortname: "Vailets",
    },
    "falconsvilanova": {
        color: "#483B8A",
        fullname: "Falcons de Vilanova i la Geltrú",
        shortname: "Falcons de Vilanova",
    }
}

const LOADING = {
    color: "#FFF",
    fullname: "Carregant...",
    shortname: "Carregant...",
}

export const COLLES = Object.keys(_SETTINGS);

const SETTINGS = (colla) => {
    if (colla in _SETTINGS) return _SETTINGS[colla];
    else return LOADING;
}

export default SETTINGS;
